import React, { Component } from 'react';
import scrollToComponent from 'react-scroll-to-component';

import Nav from '../components/nav';
import Devices from '../sections/devices';
import Intro from '../sections/intro';
import Principles from '../sections/principles';
import Resources from '../sections/resources';
import SitesPages from '../sections/sitesPages';
import Toolkits from '../sections/toolkits';
import WebParts from '../sections/webParts';

class IndexPage extends Component {
  // Re-render the component to send refs to Nav.
  componentDidMount() {
    this.forceUpdate();
  }

  render() {
    return (
      <div>
        <Nav
          onClick={this.handleClick}
          links={[
            {
              text: 'Design principles',
              section: this.refs.principles,
            },
            {
              text: 'Sites & pages',
              section: this.refs.sitesPages,
            },
            {
              text: 'Web parts',
              section: this.refs.webParts,
            },
            {
              text: 'Platforms',
              section: this.refs.devices,
            },
            {
              text: 'Resources',
              section: this.refs.toolkits,
            },
            {
              text: 'Frameworks',
              section: this.refs.resources,
            },
            {
              text: 'SharePoint Look Book',
              url: 'https://aka.ms/sharepointlookbook',
              isExternal: true,
            },
          ]}
        />
        <Intro />
        <div ref="principles">
          <Principles />
        </div>
        <div ref="sitesPages">
          <SitesPages />
        </div>
        <div ref="webParts">
          <WebParts />
        </div>
        <div ref="devices">
          <Devices />
        </div>
        <div ref="toolkits">
          <Toolkits />
        </div>
        <div ref="resources">
          <Resources />
        </div>
      </div>
    );
  }

  handleClick = (section, url) => {
    if (url) {
      window.open(url, '_blank');
    }

    scrollToComponent(section, {
      offset: -76, // Overscroll slightly to ensure there's no gap.
      align: 'top',
      duration: 800,
    });
  };
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js